var _excluded = ["altLinks", "children", "className", "striped", "tight", "spacious", "comfy", "compact"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import PropTypes from "prop-types";
import React, { forwardRef } from "react";
import "./ASimpleTable.scss";
var ASimpleTable = /*#__PURE__*/forwardRef(function (_ref, ref) {
  var altLinks = _ref.altLinks,
    children = _ref.children,
    propsClassName = _ref.className,
    striped = _ref.striped,
    tight = _ref.tight,
    spacious = _ref.spacious,
    comfy = _ref.comfy,
    compact = _ref.compact,
    rest = _objectWithoutProperties(_ref, _excluded);
  var className = "a-simple-table";
  if (altLinks) {
    className += " a-simple-table--alt-links";
  }
  if (striped) {
    className += " a-simple-table--striped";
  }
  if (tight) {
    className += " a-simple-table--tight";
  } else if (compact) {
    className += " a-simple-table--compact";
  } else if (comfy) {
    className += " a-simple-table--comfy";
  } else if (spacious) {
    className += " a-simple-table--spacious";
  } else {
    className += " a-simple-table--compact";
  }
  if (propsClassName) {
    className += " ".concat(propsClassName);
  }
  return /*#__PURE__*/React.createElement("table", _extends({}, rest, {
    ref: ref,
    className: className
  }), children);
});
ASimpleTable.propTypes = {
  /**
   * Toggles the `altLinks` display variant. If the table has many links, use this to display them in the base text color.
   */
  altLinks: PropTypes.bool,
  /**
   * Toggles the `striped` display variant. Darkened backgrounds for alternate rows.
   */
  striped: PropTypes.bool,
  /**
   * Toggles the `tight` display variant. Smaller row heights.
   */
  tight: PropTypes.bool,
  /**
   * Toggles the `compact` display variant. Medium row heights.
   */
  compact: PropTypes.bool,
  /**
   * Toggles the `comfy` display variant. Large row heights.
   */
  comfy: PropTypes.bool,
  /**
   * Toggles the `spacious` display variant. Largest row heights.
   */
  spacious: PropTypes.bool
};
ASimpleTable.displayName = "ASimpleTable";
export default ASimpleTable;